











































































































































































import {
  apiMarketingCouponGetCouponReceiveInfo,
  apiMarketingCouponReceiveOpen,
  apiPageConfigGetStateContentByApp,
} from '@/api'
import { computed, onActivated, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi } from '@/hooks'
import { devOrProd, prepareData, submit, Track } from '@/utils'
import {
  loadResource,
  LoadResourceUrlType,
  mapValues,
  omitStrict,
  values,
} from 'vtils'
import { MayConsumerCouponImages } from './images'
import { PageUtils, useWaterfall, XWaterfallLoad } from '@/components'
import { wechat } from '@/wechat'

interface PageType {
  优惠券类型: '家清日化券' | '百灵文娱消费券' | '苗姑娘专享券' | '全部'
  优惠券状态: '可领取' | '已领取' | '已领完'
}

const 优惠券ID: Record<PageType['优惠券类型'], string[]> = {
  家清日化券: devOrProd(
    ['8aaa85c480f3994f0180f3d9e3350014'],
    ['8aaae37480d6f81f0180ef718c902527'],
  ),
  百灵文娱消费券: devOrProd(
    ['8aaa85c480f3994f0180f3d871810012'],
    ['8aaae37480d6f81f0180ef70e5772525'],
  ),
  苗姑娘专享券: devOrProd(
    ['8aaa85c480f3994f0180f3d6df980010'],
    ['8aaa8c3780d6f2550180ef6fe5026360'],
  ),
  全部: [],
}

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '五月消费券',
        }))

        onActivated(() => {
          wechat.updateShareData({
            title: '多彩宝消费季，百万消费券等你来抢',
            desc: '精彩纷呈，爽酷一夏',
            link: location.href,
            imgUrl:
              'https://cdn-resource.gogpay.cn/npm/_/1653297725hPJFCY.png',
          })
        })
      }

      shareParams = PageUtils.defineShareParams(() => ({
        title: '多彩宝消费季，百万消费券等你来抢',
        desc: '精彩纷呈，爽酷一夏',
        cover: 'https://cdn-resource.gogpay.cn/npm/_/1653297725hPJFCY.png',
      }))

      apiData = useApi(async () => {
        const data = await prepareData({
          images: loadResource(
            values(MayConsumerCouponImages).map(url => ({
              type: LoadResourceUrlType.img,
              path: url,
            })),
          ),
          推荐数据: apiPageConfigGetStateContentByApp({
            stateId: devOrProd(
              '8aaa85a880c17f710180da796b8a01a7',
              '8aaa85a880c17f710180da796b8a01a7',
            ),
            pageIndex: 1,
            pageSize: 10,
          }).then(res => res.list),
        })
        return data
      })

      couponApiData = useApi(async () => {
        const data = await prepareData(
          mapValues(优惠券ID, ids => {
            return Promise.all(
              ids.map(id =>
                apiMarketingCouponGetCouponReceiveInfo({
                  couponActId: id,
                }),
              ),
            ).then<PageType['优惠券状态']>(res => {
              let canReceive = false
              for (const item of res) {
                if (item.receiveStatus === 1) {
                  return '已领取'
                }
                if (item.receiveStatus === 0) {
                  canReceive = true
                }
              }
              return canReceive ? '可领取' : '已领完'
            })
          }),
        )
        return data
      })

      categoryIndex = ref(0)

      waterfall = useWaterfall('waterfall', {
        reloadWatcher: () => this.categoryIndex.value,
      })

      推荐数据 = computed(() => this.apiData.data.推荐数据)

      currentBannerIndex = ref(0)

      点击使用指南 = () => {
        dcb.navigateTo({
          url: 'https://wap.gogpay.cn/8aaa86d67aebce0f0180da6152b600fa',
        })
      }

      点击活动规则 = () => {
        dcb.navigateTo({
          url: 'https://wap.gogpay.cn/8aaa86d67aebce0f0180da60c6b700f9',
        })
      }

      优惠券状态 = computed(() => {
        const data = omitStrict(this.couponApiData.data, ['全部'])
        const status = values(data)
        return {
          ...data,
          全部: status.every(item => item === '可领取')
            ? '可领取'
            : status.some(item => item === '已领取')
            ? '已领取'
            : '已领完',
        }
      })

      点击优惠券 = (type: PageType['优惠券类型']) => {
        if (this.优惠券状态.value[type] === '可领取') {
          submit(async $ => {
            $.start('领取中...')
            await Promise.all(
              (type === '全部'
                ? values(优惠券ID).flat()
                : 优惠券ID[type]
              ).map(id =>
                apiMarketingCouponReceiveOpen({
                  couponActId: id,
                }),
              ),
            )
            await this.couponApiData.refresh()
            await $.success('领取成功')
          })
        } else if (this.优惠券状态.value[type] === '已领取') {
          PageUtils.scrollTo(ctx.$refs.title)
        }
      }

      加载商品数据: XWaterfallLoad = ({ pageNumber }) => {
        return apiPageConfigGetStateContentByApp({
          stateId:
            this.categoryIndex.value === 0
              ? '8aaaeba77e7cb5b1017f5464496f04c0'
              : this.categoryIndex.value === 1
              ? '8aaaeba77e7cb5b1017f54651b6c04c5'
              : '8aaaeba77e7cb5b1017f54662a0c04ca',
          pageIndex: pageNumber,
          pageSize: 10,
        }).then(res => res.list) as any
      }
    },
)
